import { useCallback } from 'react';
import TTLLocalStorage from '../../utils/TTLLocalStorage';

const SESSION_KEY = 'monkeybook-manage_passes_session';
const SIX_MONTHS_MS = 180 * 24 * 60 * 60 * 1000;

export type ManagePassesSession = {
  email: string;
  orderNumber: number;
  accountId: string;
};

export const useManagePassesSession = () => {
  const getSession = useCallback((): ManagePassesSession | null => {
    return TTLLocalStorage.getItem(SESSION_KEY);
  }, []);

  const saveSession = useCallback((session: ManagePassesSession) => {
    TTLLocalStorage.setItem(SESSION_KEY, session, SIX_MONTHS_MS);
  }, []);

  const clearSession = useCallback(() => {
    TTLLocalStorage.removeItem(SESSION_KEY);
  }, []);

  return { getSession, saveSession, clearSession };
};
